import DASH from "../../assets/images/dash.webp";
import write from "../../assets/images/write.png"
import Ovatave from "../../assets/images/ovatave.webp";
import PSR from "../../assets/images/psr.webp";
// import Manage from "../../assets/images/manage.webp";
import Portfolio from "../../assets/images/banner-port.webp";
import wetter from "../../assets/images/wetter.webp";
import om from "../../assets/images/om.webp";
// import html from "../../assets/icons/html5.svg";
// import css from "../../assets/icons/css3.svg";
// import js from "../../assets/icons/javascript.svg";
import React from "../../assets/icons/react.svg";
import redux from "../../assets/icons/redux.svg";
import reactrouter from "../../assets/icons/reactrouter.svg";
import styledcomp from "../../assets/icons/styledcomponents.svg";
import netlify from "../../assets/icons/netlify.svg";
import swiper from "../../assets/icons/swiper.svg";
import gsap from "../../assets/icons/greensock.svg";
import firebase from "../../assets/icons/firebase.svg";

export const projectData = [
  {
    title: "Datamellon",
    description:
      "Datamellon is a leading software development company with a strong presence in Europe, Africa, America. They specialize in delivering simple, fast, and secure AI solutions, making them an essential business partner at any stage of your digital transformation. ",
    tools: [
      "TypeScript",
      "Next.Js",
    ],
    icons: [React, redux, styledcomp, gsap, reactrouter, netlify],
    live: "https://writetechhub.org",
    // github: "https://github.com/OfficialJhimmy/Dash-Language-Place",
    img: write,
  },
  {
    title: "WriteTech Hub",
    description:
      "The main purpose of this project was to provide technical writing solutions to individuals or businesses. ",
    tools: [
      "ReactJs",
      "Redux",
      "Styled Components",
      "GSAP",
      "React Router",
      "Netlify",
    ],
    icons: [React, redux, styledcomp, gsap, reactrouter, netlify],
    live: "https://writetechhub.org",
    // github: "https://github.com/OfficialJhimmy/Dash-Language-Place",
    img: write,
  },
  {
    title: "Dash Language School",
    description:
      "The main purpose of this project was to provide a payment and informational platform for a language school with offices in Lagos, Nigeria. This website was created to provide various users with comprehensive information on the four foreign languages the school offers. Using a secure payment gateway, a user can preview a course, choose whether it fits into their schedule, then pay for it using Paystack.",
    tools: [
      "ReactJs",
      "Redux",
      "Styled Components",
      "GSAP",
      "React Router",
      "Netlify",
    ],
    icons: [React, redux, styledcomp, gsap, reactrouter, netlify],
    live: "https://dashlanguageschool.com.ng",
    // github: "https://github.com/OfficialJhimmy/Dash-Language-Place",
    img: DASH,
  },
  // {
  //   title: "O.M Associates",
  //   description:
  //     "This project's primary goal was to disseminate knowledge about a renowned tax and auditing organization with its main offices in Lagos, Nigeria. Users can learn more about the services the company offers through the Web app. A Content Management System was also developed using React.Js and Firebase, to easily manage contents on the website.",
  //   tools: ["ReactJs", "Redux", "Firebase", "React Router", "Netlify"],
  //   icons: [React, redux, firebase, reactrouter, netlify],
  //   live: "https://omassociates.com.ng/",
  //   github: "https://github.com/OfficialJhimmy/om-new",
  //   img: om,
  // },
  // {
  //   title: "Ovatave",
  //   description:
  //     "This project's major objective was to showcase the agency's next generation of singers, models, athletes, and digital entrepreneurs and celebrate its success in the entertainment industry.",
  //   tools: ["ReactJs", "GSAP", "Netlify"],
  //   icons: [React, gsap, netlify],
  //   live: "http://ovatave.netlify.app/",
  //   github: "https://github.com/OfficialJhimmy/Ovatave",
  //   img: Ovatave,
  // },
  // {
  //   title: "Property Sales Reality",
  //   description:
  //     "This project's major objective was to display available properties that were listed in Lagos, Nigeria. Properties can be filtered by the following criteria: luxury, featured, for sale, and for rent. Additionally, it has a page called the 'admin dashboard' that acts as the app's content management system. Firebase and React.js were used to build this project.",
  //   tools: ["ReactJs", "Redux", "Firebase", "React Router", "Netlify"],
  //   icons: [React, redux, firebase, reactrouter, netlify],
  //   live: "http://propertysalesreality.netlify.app/",
  //   github: "https://github.com/OfficialJhimmy/Property-Sales-Reality",
  //   img: PSR,
  // },
  // {
  //   title: "My Portfolio",
  //   description:
  //     "The main goal of this project was to showcase all of my current projects, my biography, my accomplishments, and some specific information on how people can contact me.",
  //   tools: [
  //     "ReactJs",
  //     "GSAP",
  //     "Swiper Js",
  //     "React Router",
  //     "Locomotive Scroll",
  //   ],
  //   icons: [React, gsap, swiper, reactrouter],
  //   live: "http://jhimmyofficial.netlify.app",
  //   github: "https://github.com/OfficialJhimmy/portfolio",
  //   img: Portfolio,
  // },
  // {
  //   title: "Wetter",
  //   description:
  //     "Wetter!, your sleek, user-friendly weather forecaster. With a modern user interface, it's 98% accurate!",
  //   tools: ["ReactJs", "React Router", "Netlify"],
  //   icons: [React, reactrouter, netlify],
  //   live: "https://weather-dasboard.netlify.app",
  //   github: "https://github.com/OfficialJhimmy/react-weather-dashboard",
  //   img: wetter,
  // },
  // {
  //   title: "Manage",
  //   description: "A Front-End Mentor Challenge!",
  //   tools: ["HTML5", "CSS3", "JavaScript", "Netlify"],
  //   icons: [html, css, js, netlify],
  //   live: "http://manage-front.netlify.app/",
  //   github: "https://github.com/OfficialJhimmy/manage-landing-page",
  //   img: Manage,
  // },
];
